import React from 'react';
import { ActivityNumberInput } from './activity-number-input';

export interface ActivityValue {
  daysPerWeek: number;
  minutesPerDay: number;
}

export interface Activity {
  id: string;
  name: string;
  values: ActivityValue;
}

interface ActivityNumberStepperProps {
  activities: Activity[];
  onChange: (activityId: string, values: ActivityValue) => void;
  onDeselectAll?: () => void;
}

export const ActivityNumberStepper: React.FC<ActivityNumberStepperProps> = ({
  activities,
  onChange,
  onDeselectAll,
}) => {
  const handleDaysChange = (activityId: string, days: number) => {
    const activity = activities.find((a) => a.id === activityId);
    if (activity) {
      onChange(activityId, {
        ...activity.values,
        daysPerWeek: days,
      });
    }
  };

  const handleMinutesChange = (activityId: string, minutes: number) => {
    const activity = activities.find((a) => a.id === activityId);
    if (activity) {
      onChange(activityId, {
        ...activity.values,
        minutesPerDay: minutes,
      });
    }
  };

  return (
      <div className="activity-cards-grid">
        {activities.map((activity) => {
          return (
            <div key={activity.id} className="activity-card">
              <h3 className="activity-card-title">{activity.name}</h3>
              <div className="activity-inputs-container">
                <ActivityNumberInput
                  label="Days per week"
                  value={activity.values.daysPerWeek}
                  onChange={(value) => handleDaysChange(activity.id, value)}
                  min={0}
                  max={7}
                />
                <ActivityNumberInput
                  label="Minutes per day"
                  value={activity.values.minutesPerDay}
                  onChange={(value) => handleMinutesChange(activity.id, value)}
                  stepSize={5}
                  min={0}
                  max={1440} // 24 hours * 60 minutes
                />
              </div>
            </div>
          );
        })}
      </div>
  );
};
